export const actionTypePrefix = '@@USERS';
export const friendsStreamId = '@@USERS_FRIENDS';
export const supportersStreamId = '@@USERS_SUPPORTERS';

//# sourceMappingURL=constants.js.map